import React from 'react';
import { MultiSelect } from '@roger/ui-components';
import { Question } from '../types';

interface MultiSelectQuestionProps {
  question: Question;
  value: string[];
  onChange: (value: string[]) => void;
}

export const MultiSelectQuestion: React.FC<MultiSelectQuestionProps> = ({
  question,
  value = [],
  onChange,
}) => {
  if (!question.values) {
    return (
      <div className='text-red-600'>MultiSelect question missing values</div>
    );
  }

  const options = question.values.map(val => ({
    value: val,
    label: question.value_description?.[val]
      ? `${val} - ${question.value_description[val]}`
      : val,
  }));

  // Determine column count based on number of options
  const getColumns = (): number | undefined => {
    const count = options.length;
    if (count >= 16) return 3;
    if (count >= 8) return 2;
    return undefined;
  };

  return (
    <div className='space-y-2'>
      <label className='text-sm font-semibold text-foreground block'>
        {question.question || question.description}
      </label>

      <MultiSelect
        options={options}
        value={value}
        onChange={onChange}
        orientation='vertical'
        columns={getColumns()}
      />
    </div>
  );
};
